import React from 'react';
import { Container } from './styles';

type Props = {
    layout?: 'auth' | 'main' | 'home' | 'lp';
    type: 'success' | 'error';
    message: string;
    ms: number;
};

const Snackbar: React.FC<Props> = ({  layout = 'main', type, message, ms }) => {
    return (
        <Container
            $authLayout={layout === 'auth'}
            $lp={layout === 'lp'}
            $success={type === 'success'}
            $error={type === 'error'}
            $ms={ms}
        >
            <span>{message}</span>
        </Container>
    );
};

export { Snackbar };
